import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaQuoteLeft } from 'react-icons/fa';
import './Home.css';

import About from '../About/About'
import home from '../../Assets/Image/banner/homee.jpg';
import camel1 from '../../Assets/Image/banner/camel1.jpg';
import camels from '../../Assets/Image/banner/camels.jpg';
import volcano2 from '../../Assets/Image/banner/volcano2.jpg';
import rock from '../../Assets/Image/banner/rock.jpg';



import yangudi from '../../Assets/Image/things-todo/yangudi.jpg';
import sulphur from '../../Assets/Image/things-todo/sulphur.jpg';
import caption1 from '../../Assets/Image/things-todo/caption1.jpg';
import caption4 from '../../Assets/Image/things-todo/caption4.jpg';
import caption2 from '../../Assets/Image/things-todo/caption2.jpg';
import caption from '../../Assets/Image/things-todo/caption.jpg';
import Services from './Services';
// import Testimonials from './Testimonial'
import Attractions from './Attractions'
import Mapping from './ExperienceSection'
  const Home = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [testimonials, setTestimonials] = useState([]);
    const [currentTestimonial, setCurrentTestimonial] = useState(0);
    const bannerSlides = [
      { src: home, caption: 'Explore Beautiful Landscapes' },
      { src: rock, caption: 'Unforgettable Cityscapes' },
      { src: volcano2, caption: 'Adventure Awaits in the Mountains' },
      { src: camels, caption: 'Relax by the Beach' },
      { src: camel1, caption: 'Escape into the Wilderness' },
    ];
  
  
    const attractions = [
      {
        id: 1,
        title: 'Blue Nile Falls',
        description: 'The Blue Nile Falls  down the cliffs, leaving behind misty rainbows.',
        image: yangudi,
      },
      {
        id: 2,
        title: 'Shonke Village',
        description: ' in the mountains, filled with tradition and stunning landscapes.',
        image: sulphur,
      },
      {
        id: 3,
        title: 'Fasil Ghebbi',
        description: 'A historical castle complex that takes you back to the reign of ancient Ethiopian emperors.',
        image: caption1,
      },
      {
        id: 4,
        title: 'Danakil Depression',
        description: 'Explore one of Earth with active lava lakes and salt plains.',
        image: caption2,
      },
      {
        id: 5,
        title: 'Lake Afrera',
        description: 'Relax by the beautiful salt lake surrounded by hot springs and salt production sites.',
        image: caption4,
      },
      {
        id: 6,
        title: 'Erta Ale Volcano',
        description: 'Trek to this active volcano and experience the glowing lava lake at night.',
        image: caption,
      },
    ];
    useEffect(() => {
      // Simulate fetching testimonials from an API
      const fetchTestimonials = async () => {
        // Replace this with your actual API call
        const dummyTestimonials = [
          {
            id: 1,
            name: "John Smith",
            role: "Adventure Traveler",
            text: "The Afar region offered an incredible experience that I'll never forget. The volcanic landscapes and salt flats were absolutely breathtaking.",
            rating: 5
          },
          {
            id: 2,
            name: "Sarah Johnson",
            role: "Cultural Explorer",
            text: "The local communities were so welcoming and the cultural experiences were authentic. It was truly a life-changing journey.",
            rating: 5
          },
          {
            id: 3,
            name: "Michael Chen",
            role: "Photography Enthusiast",
            text: "As a photographer, the Danakil Depression provided some of the most unique and stunning landscapes I've ever captured.",
            rating: 5
          },
          {
            id: 1,
            name: "John Smith",
            role: "Adventure Traveler",
            text: "The Afar region offered an incredible experience that I'll never forget. The volcanic landscapes and salt flats were absolutely breathtaking.",
            rating: 5
          },
          {
            id: 2,
            name: "Sarah Johnson",
            role: "Cultural Explorer",
            text: "The local communities were so welcoming and the cultural experiences were authentic. It was truly a life-changing journey.",
            rating: 5
          },
          {
            id: 3,
            name: "Michael Chen",
            role: "Photography Enthusiast",
            text: "As a photographer, the Danakil Depression provided some of the most unique and stunning landscapes I've ever captured.",
            rating: 5
          },
          {
            id: 1,
            name: "John Smith",
            role: "Adventure Traveler",
            text: "The Afar region offered an incredible experience that I'll never forget. The volcanic landscapes and salt flats were absolutely breathtaking.",
            rating: 5
          },
          {
            id: 2,
            name: "Sarah Johnson",
            role: "Cultural Explorer",
            text: "The local communities were so welcoming and the cultural experiences were authentic. It was truly a life-changing journey.",
            rating: 5
          },
          {
            id: 3,
            name: "Michael Chen",
            role: "Photography Enthusiast",
            text: "As a photographer, the Danakil Depression provided some of the most unique and stunning landscapes I've ever captured.",
            rating: 5
          }
        ];
        setTestimonials(dummyTestimonials);
      };
    
      fetchTestimonials();
    }, []);
    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentTestimonial(prev => 
          prev === testimonials.length - 1 ? 0 : prev + 1
        );
      }, 5000);
    
      return () => clearInterval(interval);
    }, [testimonials.length]);
    useEffect(() => {
      const interval = setInterval(() => {
        setActiveIndex((prevIndex) =>
          prevIndex === bannerSlides.length - 1 ? 0 : prevIndex + 1
        );
      }, 5000);
  
      return () => clearInterval(interval);
    }, [bannerSlides.length]);
  
    return (
      <div className="home-page">
        {/* Hero Banner Section */}
        <section className="hero-section">
          <div className="hero-slider">
            {bannerSlides.map((slide, index) => (
              <div 
                key={index} 
                className={`hero-slide ${index === activeIndex ? 'active' : ''}`}
                style={{ backgroundImage: `url(${slide.src})` }}
              >
                <div className="hero-content">
                  <h1 className="animate__animated animate__fadeInDown">
                    {slide.caption}
                  </h1>
                  <h3 className="animate__animated animate__fadeInUp">
                    {slide.caption}
                  </h3>
                  <p className="animate__animated animate__fadeIn">
                    {slide.description}
                  </p>
                  <button className="cta-button animate__animated animate__fadeInUp">
                    Explore Now
                  </button>
                </div>
              </div>
            ))}
          </div>
          
          <div className="hero-controls">
            {bannerSlides.map((_, index) => (
              <button 
                key={index}
                className={`dot ${index === activeIndex ? 'active' : ''}`}
                onClick={() => setActiveIndex(index)}
              />
            ))}
          </div>
        </section>
  
        {/* About Section */}
         <About/>
        <Services/>
        {/* Attractions Section */}
        {/* <section className="attractions-section">
            <Container>
                <h2 className="section-title">Popular Attractions</h2>
                <Row>
                    {attractions.map((attraction) => (
                        <Col lg={4} md={6} sm={12} key={attraction.id}>
                            <div className="attraction-card">
                                <div className="attraction-image">
                                    <img src={attraction.image} alt={attraction.title} />
                                </div>
                                <div className="attraction-content">
                                    <h3>{attraction.title}</h3>
                                    <p>{attraction.description}</p>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section> */}
      <Attractions attractions={attractions} />
      {/* <Testimonials testimonials={testimonials} /> */}
        {/* testimonials */}
        <section className="testimonials-section">
         <Container>
         <h2 className="section-title">What Our Visitors Say</h2>
            <div className="testimonials-carousel">
          <div className="testimonials-track">
            {testimonials.map((testimonial, index) => (
              <div
                key={testimonial.id}
                className={`testimonial-card ${
                  index === currentTestimonial || 
                  index === (currentTestimonial + 1) % testimonials.length || 
                  index === (currentTestimonial + 2) % testimonials.length 
                    ? 'active' 
                    : ''
                }`}
                style={{
                  transform: `translateX(-${currentTestimonial * 33.33}%)`
                }}
              >
                <div className="quote-icon">
                  <FaQuoteLeft />
                </div>
                <div className="testimonial-content">
                  <p className="testimonial-text">{testimonial.text}</p>
                  <div className="testimonial-author">
                    <h4>{testimonial.name}</h4>
                    <p>{testimonial.role}</p>
                    <div className="rating">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <span key={i} className="star">⭐</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="carousel-controls">
            <button 
              className="carousel-control prev"
              onClick={() => setCurrentTestimonial(prev => 
                prev === 0 ? testimonials.length - 1 : prev - 1
              )}
            >
              ❮
            </button>
            <div className="testimonial-dots">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  className={`dot ${index === currentTestimonial ? 'active' : ''}`}
                  onClick={() => setCurrentTestimonial(index)}
                />
              ))}
            </div>
            <button 
              className="carousel-control next"
              onClick={() => setCurrentTestimonial(prev => 
                prev === testimonials.length - 1 ? 0 : prev + 1
              )}
            >
              ❯
            </button>
          </div>
        </div>
      </Container>
        </section>
        {/* mapp */}
        <Mapping/>
      </div>
    );
  };
  
  export default Home;